import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import MarkPaidModal from './MarkPaidModal';
import ClosePOModal from './ClosePOModal';
import IssueModal from './IssueModal';
import DeletePOModal from './DeletePOModal';
import MarkFulfilledModal from './MarkFulfilledModal';

import DownloadPdfModal from './DownloadPdfModal';

import { purchaseOrdersIndex, resetNewPurchaseOrder, reset } from '../../redux/actions/purchaseOrders';
import { suppliersIndex } from '../../redux/actions/suppliers';

const PurchaseOrders = ({ payload, loadPurchaseOrders, loadSuppliers, purchaseOrders, suppliers, clearNewPurchaseOrder, resetPurchaseOrders, settings }) => {
  const [modalOrder, setModalOrder] = useState(null);
  const [showMarkPaidModal, setShowMarkPaidModal] = useState(false);
  const [showUpdateShipmentModal, setShowUpdateShipmentModal] = useState(false);
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [showClosePOModal, setShowClosePOModal] = useState(false);
  const [showDeletePOModal, setShowDeletePOModal] = useState(false);
  const [showShipmentsModal, setShowShipmentsModal] = useState(false);
  const [showMarkFulfilledModal, setShowMarkFulfilledModal] = useState(false);
  const [showDownloadPdfModal, setShowDownloadPdfModal] = useState(false);

  const [reverseOrder, setReverseOrder] = useState(true);
  const [sortKey, setSortKey] = useState(null);

  const [page, setPage] = useState(0);

  useEffect(() => {
    loadNextPurchaseOrders();
    loadSuppliers(payload);
    clearNewPurchaseOrder();
  }, []);


  const loadPreviousPurchaseOrders = () => {
    let previousContinuationToken = purchaseOrders.purchaseOrdersSearchStack[page - 2];
    loadPurchaseOrders(payload, previousContinuationToken, (page - 1), sortKey, reverseOrder);
    setPage(page - 1);
  }

  const loadNextPurchaseOrders = () => {
    loadPurchaseOrders(payload, purchaseOrders.purchaseOrdersSearchStack[page], (page + 1), sortKey, reverseOrder);
    setPage(page + 1);
  }

  const openMarkIssued = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowIssueModal(true);
  }

  const openMarkFulfilled = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowMarkFulfilledModal(true);
  }

  const openMarkPaid = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowMarkPaidModal(true);
  }

  const openMarkClosed = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowClosePOModal(true);
  }

  const openMarkDeleted = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowDeletePOModal(true);
  }

  const openShipments = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowShipmentsModal(true);
  }

  const openDownloadPdf = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowDownloadPdfModal(true);
  }


  const supplierData = (supplierId) => {
    let supplier = suppliers.suppliers.find(supplier => supplier.id === supplierId);

    if(supplier) {
      return (
        <>
          <strong>Supplier</strong>: { supplier.supplier_name }
          <br/>
          { supplier.account_number &&
            <>
              <strong>Account Number</strong>: { supplier.account_number }
              <br/>
            </>
          }
          { supplier.contact_email &&
            <>
              <strong>Contact Email</strong>: { supplier.contact_email }
              <br/>
            </>
          }
          { supplier.contact_phone &&
            <>
              <strong>Contact Phone</strong>: { supplier.contact_phone }
              <br/>
            </>
          }
        </>
      )
    }

    return(
      <>
        <p><strong>Supplier</strong>: Supplier no longer exists</p>
      </>
    )
  }


  const setOrder = (order) => {
    setSortKey(order);
    resetPurchaseOrders();
    loadPurchaseOrders(payload, null, 1, order, reverseOrder);
    setPage(1);
    clearNewPurchaseOrder();
  }

  const switchOrder = () => {
    setReverseOrder(!reverseOrder);
    resetPurchaseOrders();
    loadPurchaseOrders(payload, null, 1, sortKey, !reverseOrder);
    setPage(1);
    clearNewPurchaseOrder();
  }

  return(
    <>
      <PageHeader stripeBackground='#070808' helpLink="ecwid/manage-purchase-orders-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Purchase Orders</div>
              </div>
              <div className="named-area__description">
                <p>From this page, you can manage purchase orders.</p>
                <p>Click the "New Purchase Order" button to start a new purchase order, or take actions on the outstanding purchase orders from the panel below.</p>
                <p>Paginate through sets of 10 purchase orders by clicking the "Previous Purchase Orders" or "Next Purchase Orders" buttons.</p>
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <Link to="/purchase_order/new">
                      <button className="btn btn-primary">
                        <span className="svg-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                        </span>
                        <span className="gwt-InlineLabel">New Purchase Order</span>                        
                      </button>
                    </Link>
                    <hr/>
                    <Link to="/purchase_orders/archived">
                      <button className="btn btn-link">
                        <span className="svg-icon">
                          <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
                        </span>
                        <span className="gwt-InlineLabel">View Archived Purchase Orders</span>    
                      </button>
                    </Link>
                    <span className="left-15">
                      <Link to="/purchase_orders/rejected">
                        <button className="btn btn-link">
                          <span className="svg-icon">
                            <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
                          </span>
                          <span className="gwt-InlineLabel">View Rejected Purchase Orders</span>
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    <h3>Sort Options</h3>

                    <div className="flex-container">
                      <div className="flex-1">
                        <h4>Sort Key</h4>

                        <div className="radio radio--small">
                          <label for="creation_date">
                            <input type="radio" name="sortKey" value="on" className="" id="creation_date" checked={sortKey === null} onChange={ () => setOrder(null) } />
                            <span className="radio-label">
                              <span className="radio-label-title">Creation Date</span>
                            </span>
                          </label>
                        </div>
                        <div className="radio radio--small">
                          <label for="invoice_number">
                            <input type="radio" name="sortKey" value="on" className="" id="invoice_number" checked={sortKey === 'invoice_number'} onChange={ () => setOrder('invoice_number') } />
                            <span className="radio-label">
                              <span className="radio-label-title">{`${settings.settings['invoice_number_override'] || 'Invoice Number'}`}</span>
                            </span>
                          </label>
                        </div>
                        <div className="radio radio--small">
                          <label for="supplier_number">
                            <input type="radio" name="sortKey" value="on" className="" id="supplier_number" checked={sortKey === 'supplier_number'} onChange={ () => setOrder('supplier_number') } />
                            <span className="radio-label">
                              <span className="radio-label-title">{`${settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}`}</span>
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="flex-1">
                        <h4>Reverse Order</h4>
                        <label className="checkbox tiny">
                          <input name="" type="checkbox" checked={reverseOrder} onClick={() => switchOrder()} />
                          <div data-on="Reversed" data-off="Normal"><div></div></div>
                          <span className="checkbox__on-text-placeholder">Reversed</span>
                          <span className="checkbox__off-text-placeholder">Normal</span>
                        </label>
                      </div>

                    </div>


                  </div>
                </div>

              </div>
            </div>

            

          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title"></div>
              </div>
              <div className="named-area__description">
                <p>For new, draft purchase orders, you can download the PDF to send to the supplier, edit the purchase order, or mark the draft as issued, or paid by clicking the buttons to the right of the purchase order's row.</p>
                <p>For issued purchase orders, or partially fulfilled purchase orders, you can download the order's PDF, update incoming shipment information to help track shipments from suppliers, mark the purchase order paid, update parts of the purchase order or receive shipments for the order by clicking buttons to the right of the purchase order's row.</p>
                <p>For fulfilled purchase orders, you can download the purchase order's PDF, mark the order as paid or close the purchase order by clicking buttons to the right of the purchase order's row.</p>
                <p>You can cancel or reject the remaining steps for any purchase order at any time by clicking the red garbage can icon on any purchase order's row.</p>
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { purchaseOrders.status !== 'success' && <LoadingSpinner size="xxSmall" statusText="Loading Purchase Orders" /> }

                    { purchaseOrders.status === 'success' && purchaseOrders.purchaseOrders.length === 0 &&
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings">
                          <p>No outstanding purchase orders. When you have incomplete purchase orders, you'll see them in a list here.</p>
                          <Link to="/purchase_order/new">
                            <button className="btn btn-primary">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                              </span>
                              <span className="gwt-InlineLabel">New Purchase Order</span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    }


                    { purchaseOrders.purchaseOrders.map(purchaseOrder =>
                        <>
                          <h4>
                            {purchaseOrder.invoice_number || purchaseOrder.id}
                            <span className="left-15">
                              <Link to={`/purchase_order/copy/${purchaseOrder.id}`}>
                                <button className="btn btn-default btn-small">
                                  <span className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5 4V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1.0001 1.0001 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H2.007a1.0007 1.0007 0 0 1-.93-.6159A1.0007 1.0007 0 0 1 1 17l.003-12c0-.552.45-1 1.007-1H5zM3.003 6 3 16h8V6H3.003zM7 4h5c.5523 0 1 .4477 1 1v7h2V2H7v2z"/></svg>
                                  </span>
                                  <span className="gwt-InlineLabel">Copy</span>
                                </button>
                              </Link>

                              <span className="left-15">
                                <button
                                  className="btn btn-delete btn-small"
                                  onClick={() => openMarkDeleted(purchaseOrder)}
                                  disabled={purchaseOrders.updatingRejectedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                                >
                                  <span className="svg-icon" style={{ color: '#fff' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                                  </span>
                                  <span className="gwt-InlineLabel">Delete</span>
                                </button>
                              </span>
                            </span>
                          </h4>
                          
                          <div className="flex-container space-between">
                            <div className="flex1 left-15">
                              { purchaseOrder.supplier_order_number &&
                                <>
                                  <strong>Purchase Order Number</strong>: { purchaseOrder.supplier_order_number }
                                  <br/>
                                </>
                              }
                              { purchaseOrder.supplier_id && suppliers.status === 'success' &&
                                <>
                                  {supplierData(purchaseOrder.supplier_id)}
                                </>
                              }
                              { purchaseOrder.supplier_id && suppliers.isFetching &&
                                <LoadingSpinner size="xxSmall" statusText="Loading Suppliers" />
                              }

                            </div>

                            <div className="flex1 left-15">
                              <strong>PO Status</strong>: 
                              <span className={`inline-text-tag ${ purchaseOrder.status === 'draft' && 'inline-text-tag--light-half' } ${ purchaseOrder.status === 'partially_fulfilled' && 'inline-text-tag--warning' } ${ purchaseOrder.status === 'fulfilled' && 'inline-text-tag--success' }`}>
                                { purchaseOrder.status }
                              </span>
                              <br/>
                              <strong>Type</strong>: { purchaseOrder.ship_to_type }<br/>
                              <strong>Shipment Expected</strong>: { (new Date(purchaseOrder.shipment_expected_at)).toISOString().split('T')[0] }
                              <br/>
                              { (purchaseOrder.status === 'fulfilled' || purchaseOrder.status === 'partially_fulfilled') &&
                                <Link to={`/warehouse_receiving_orders/purchase_order/${purchaseOrder.id}`}>
                                  <button className="btn btn-muted-accent btn-small">
                                    <span className="svg-icon">
                                      <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">View WROs</span>
                                  </button>
                                </Link>
                              }
                              { (purchaseOrder.status === 'partially_fulfilled') &&
                                <>
                                  <button
                                    className="btn btn-primary-accent btn-small"
                                    disabled={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                                    onClick={() => openMarkFulfilled(purchaseOrder)}
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm5.71 8.11l-5.95 6.52c-.24.24-.56.37-.87.37-.32 0-.63-.12-.87-.37L4.7 11.55c-.48-.48-.48-1.28 0-1.77a1.21 1.21 0 011.73.01l2.46 2.19 5.08-5.64a1.22 1.22 0 011.73 0c.48.5.48 1.28.01 1.77z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Mark Fulfilled</span>

                                    
                                  </button>
                                </>
                              }
                            </div>

                            <div className="flex1 left-15">
                              <strong>Payment status</strong>:
                              <span className={`inline-text-tag ${ purchaseOrder.payment_status === 'open' ? 'inline-text-tag--warning' : 'inline-text-tag--success' }`}>
                                { purchaseOrder.payment_status }
                              </span>
                              <br/>
                              <strong>Payment due</strong>: { (new Date(purchaseOrder.payment_due_at)).toISOString().split('T')[0] }
                              { purchaseOrder.payment_status === 'open' &&
                                <>
                                  <br/>
                                  <button
                                    className="btn btn-default"
                                    onClick={() => openMarkPaid(purchaseOrder) }
                                    disabled={purchaseOrders.updatingPaidList.findIndex(poId => poId === purchaseOrder.id) > -1}
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M17 6H2v11h15a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-2 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd"/><path d="M13 1 5 5h10l-2-4Z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Mark PO Paid</span>
                                  </button>
                                </>
                              }
                            </div>
                            
                            <div className="flex1 left-15 flex-container flex-column">
                              <button
                                className="btn btn-default"
                                onClick={() => openDownloadPdf(purchaseOrder)}
                              >
                                <span className="svg-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M2 16c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 1c.5523 0 1 .4477 1 1v7.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0L8 9.5858V2c0-.5523.4477-1 1-1z"/></svg>
                                </span>
                                <span className="gwt-InlineLabel">Download PDF</span>
                              </button>
                              <br/>
                              
                              { purchaseOrder.status === 'draft' &&
                                <>
                                  <Link to={`/purchase_order/edit/${purchaseOrder.id}`}>
                                    <div className="full-width">
                                      <button className="btn btn-default">
                                        <span className="svg-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                                        </span>
                                        <span className="gwt-InlineLabel">Edit PO</span>
                                      </button>
                                    </div>
                                  </Link>
                                  
                                  <br/>
                                  <button
                                    className="btn btn-primary-accent"
                                    onClick={() => openMarkIssued(purchaseOrder)}
                                    disabled={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20"><path d="M17 16v-4h2v4a1 1 0 1 1-2 0Z"/><path fill-rule="evenodd" d="M3 3h13v13a2 2 0 0 0 2 2H6a3 3 0 0 1-3-3V3Zm10 5H6.5a.5.5 0 0 0 0 1H13V8Zm0 3H8.5a.5.5 0 0 0 0 1H13v-1Z" clip-rule="evenodd"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Mark PO Issued</span>
                                  </button>
                                </>
                              }

                              { (purchaseOrder.status === 'issued' || purchaseOrder.status === 'partially_fulfilled') &&
                                <>
                                  <Link to={`/purchase_order/shipments/${purchaseOrder.id}`}>
                                    <div className="full-width">
                                      <button className="btn btn-default">
                                        <span className="svg-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.27 2.91c-.08-.5-.59-.91-1.12-.91h-7.3c-.52 0-1.04.41-1.12.91l-.72 4.18c-.08.5.29.91.83.91H2v3.08c0 .51.44.92.98.92h7.04c.55 0 .98-.41.98-.92V8h.16c.55 0 .91-.41.83-.91l-.72-4.18z"/><path d="M15 8v3.08c0 .51.44.92.98.92h7.04c.55 0 .98-.41.98-.92V8s1.07-.41.99-.91l-.71-4.18c-.09-.5-.6-.91-1.13-.91h-7.29c-.53 0-1.04.41-1.13.91l-.71 4.18c-.09.5.98.91.98.91zm7 2h-5V8h5v2zm-5.43-6h5.86l.34 2h-6.54l.34-2zm-6.42 10h-7.3c-.53 0-1.04.41-1.13.91l-.71 4.18c-.08.5.99.91.99.91v3.08c0 .51.44.92.98.92h7.04c.55 0 .98-.41.98-.92V20s1.07-.41.99-.91l-.71-4.18c-.09-.5-.6-.91-1.13-.91zm-6.58 2h5.86l.34 2H3.23l.34-2zM9 22H4v-2h5v2zm14.15-8h-7.29c-.53 0-1.04.41-1.13.91l-.71 4.18c-.09.5.98.91.98.91v3.08c0 .51.44.92.98.92h7.04c.55 0 .98-.41.98-.92V20s1.07-.41.99-.91l-.71-4.18c-.09-.5-.6-.91-1.13-.91zm-6.58 2h5.86l.34 2h-6.54l.34-2zM22 22h-5v-2h5v2z"/></svg>                                        </span>
                                        <span className="gwt-InlineLabel">Update Shipment Info</span>
                                      </button>
                                    </div>
                                  </Link>
                                  <br/>
                                  <Link to={`/purchase_order/receive/${purchaseOrder.id}`}>
                                    <div className="full-width">
                                      <button className="btn btn-primary-accent">
                                        <span className="svg-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1.17a3.001 3.001 0 0 0 5.66 0h6.34a3.001 3.001 0 0 0 5.66 0H22a1 1 0 0 0 1-1v-4a3 3 0 0 0-3-3h-.22l-1.62-6.485A2 2 0 0 0 16.22 3H2zm18.83 14H21v-3a1 1 0 0 0-1-1h-7a1 1 0 0 1-1-1V5H3v12h.17a3.001 3.001 0 0 1 5.66 0h6.34a3.001 3.001 0 0 1 5.66 0zm-3.11-6-1.5-6H14v6h3.72zM6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm11 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" fill="currentColor"/></svg>                                        </span>
                                        <span className="gwt-InlineLabel">Update or Receive Shipment</span>
                                      </button>
                                    </div>
                                  </Link>
                                </>
                              }

                              { purchaseOrder.status === 'fulfilled' &&
                                <button
                                  className="btn btn-primary-accent"
                                  disabled={ (purchaseOrder.payment_status === 'open') || (purchaseOrders.updatingClosedList.findIndex(poId => poId === purchaseOrder.id) > -1) }
                                  onClick={() => openMarkClosed(purchaseOrder) }
                                >
                                  <span className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="m13.262 12.51.879-.981a1 1 0 1 1 1.49 1.335l-.877.978-2.77 3.13a.5.5 0 0 1-.714.035l-2.252-2.074a1 1 0 0 1 1.355-1.471L11.5 14.5l1.762-1.99z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.1 5a5.002 5.002 0 0 1 9.8 0H21a1 1 0 0 1 1 1v10a7 7 0 0 1-7 7H9a7 7 0 0 1-7-7V6a1 1 0 0 1 1-1h4.1zm2.07 0a3.001 3.001 0 0 1 5.66 0H9.17zM7 7v1a1 1 0 0 0 2 0V7h6v1a1 1 0 1 0 2 0V7h3v9a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V7h3z" fill="currentColor"/></svg>                                  </span>
                                  <span className="gwt-InlineLabel">Close PO</span>
                                </button>
                              }
                            </div>
                          </div>
                          <hr/>
                        </>
                      )}

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      { showClosePOModal &&
        <ClosePOModal
          payload={payload}
          showClosePOModal={showClosePOModal}
          setShowClosePOModal={setShowClosePOModal}
          purchaseOrder={modalOrder}
        />
      }
      
      { showIssueModal &&
        <IssueModal
          payload={payload}
          showIssueModal={showIssueModal}
          setShowIssueModal={setShowIssueModal}
          purchaseOrder={modalOrder}
        />
      }

      { showDeletePOModal &&
        <DeletePOModal
          payload={payload}
          showDeletePOModal={showDeletePOModal}
          setShowDeletePOModal={setShowDeletePOModal}
          purchaseOrder={modalOrder}
        />
      }

      { showMarkPaidModal &&
        <MarkPaidModal
          payload={payload}
          showMarkPaidModal={showMarkPaidModal}
          setShowMarkPaidModal={setShowMarkPaidModal}
          purchaseOrder={modalOrder}
        />
      }

      {showMarkFulfilledModal &&
        <MarkFulfilledModal
          payload={payload}
          showMarkFulfilledModal={showMarkFulfilledModal}
          setShowMarkFulfilledModal={setShowMarkFulfilledModal}
          purchaseOrder={modalOrder}
        />
      }

      {showDownloadPdfModal &&
        <DownloadPdfModal
          payload={payload}
          purchaseOrder={modalOrder}
          showDownloadPdfModal={showDownloadPdfModal}
          setShowDownloadPdfModal={setShowDownloadPdfModal}
        />
      }

    </>
  )
}

const mapStateToProps = state => ({
  purchaseOrders: state.purchaseOrders,
  suppliers: state.suppliers,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadPurchaseOrders: (payload, continuationToken, page, sortKey, reverseOrder) => dispatch(purchaseOrdersIndex(payload, 'outstanding', continuationToken, page, sortKey, reverseOrder)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  clearNewPurchaseOrder: () => dispatch(resetNewPurchaseOrder()),
  resetPurchaseOrders: () => dispatch(reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrders);
